import { render, staticRenderFns } from "./ClientJbbfBaseCard.vue?vue&type=template&id=cc36ea5e&scoped=true&"
import script from "./ClientJbbfBaseCard.vue?vue&type=script&lang=js&"
export * from "./ClientJbbfBaseCard.vue?vue&type=script&lang=js&"
import style0 from "./ClientJbbfBaseCard.vue?vue&type=style&index=0&id=cc36ea5e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc36ea5e",
  null
  
)

export default component.exports